import Declined from './Declined';

export default Declined;
